import React, { useEffect, useState, useRef, memo } from "react";
import { TableRow } from "@material-ui/core";
import DataTableCell from "./DataTableCell";
import { isEmptyObject, fmt, formatNumberToText } from "../../../util/helper";
import { getStock } from "./stock";
import { useDispatch, useSelector } from "react-redux";

import {
  saveSyntPrice,
  saveSynToken,
  saveStrikeData,
  saveOPtickData
} from "../../../redux/actions/optionChain";
import { object } from "is_js";
const DataTableRow = React.forwardRef(({
  source,
  tokens,
  data,
  columns,
  columnIds,
  middleStrike,
  strike,
  prevData,
  lotSizeEnabled,
  lotSizesByToken,
  criticalPoints,
  saveSymbolData,
  saveCriticalPoints,
  rowClasses,
  showBuySell,
  onChangeToggle,
  selectedStrikes,
  oicepeData,
  page,
  comp,
  buySellClick,
  straddlePrice,
  type,
  isStraddle,
  chartClick,
  rowHover,
  info,
  isPosition,
  isFlipped
}, ref) => {
  const dispatch = useDispatch();
  const strikeData = useSelector((state) => state?.optionChaininstruments?.strikeData);
  const tickData = useSelector((state) => state?.optionChaininstruments?.tickData);

  const [rowData, setRowData] = useState({});
  const [criData, setCriData] = useState({});
  const subscriptionMapPE = useRef({});
  const subscriptionMapCE = useRef({});
  const rowDataRef = useRef();
  const criticalData = useRef();
 
  rowDataRef.current = data;
  criticalData.current = criData;
  useEffect(() => {
    if (data) {
      setRowData(data);
    }
  }, [data]);
  useEffect(() => {
    if (criticalPoints) {
      setCriData(criticalPoints);
    }
  }, [criticalPoints]);

  useEffect(() => {
    // subscribe for socket data
 
      if (source && tokens && tickData && Object.keys(tickData).length > 0) {
        unsubscribeToken(tokens);
        var subscription1 = source  
          .subscribe("" + tokens.PE, (message) => handleResponse(message, 'PE', tokens['strike-PE'], tokens.PE))
          .on("unsubscribe", () => {})
          .on("subscribe", () => {})
          .on("error", handleSubscribeError);
        var subscription2 = source
          .subscribe("" + tokens.CE, (message) => handleResponse(message, 'CE', tokens['strike-CE'], tokens.CE))
          .on("unsubscribe", () => {})
          .on("subscribe", () => {})
          .on("error", handleSubscribeError);
        subscriptionMapPE.current[tokens.PE] = subscription1;
        subscriptionMapCE.current[tokens.CE] = subscription2;
        return () => {
          subscription1.unsubscribe();
          subscription2.unsubscribe();
        };
      }
  }, [source, tokens, tickData]);


  const unsubscribeToken = (tokens) => {
 
        if (subscriptionMapCE.current[tokens.CE]) {
          subscriptionMapCE.current[tokens.CE]?.unsubscribe();
          subscriptionMapCE.current[tokens.CE] = "";
        }

        if (subscriptionMapPE.current[tokens.PE]) {
          subscriptionMapPE.current[tokens.PE]?.unsubscribe();
          subscriptionMapPE.current[tokens.PE] ="";
        }
 
   
    return true;
  }

  const adjustCriticalPoints = (newData, type, strike) => {
    if (criticalData.current["hightestVol"+type]?.value <  newData["vol"+type]) {
      if (criticalData.current["hightestVol"+type].strike !== strike) {
        saveCriticalPoints({...criticalData.current, ["hightestVol"+type] : {value : newData["vol"+type], strike : strike} });
      }
    }

    // if (criticalData.current["hightestOI_0"+type].value <  newData["oi"+type]) {
    //   if (criticalData.current["hightestOI_0"+type].strike !== strike) {
    //     saveCriticalPoints({...criticalData.current, ["hightestOI_0"+type] : {value : newData["oi"+type], strike : strike}});
    //   }
    // }

    // if (criticalData.current["hightestOI_0"+type].value <= criticalData.current["hightestOI_1"+type].value  && criticalData.current["hightestOI_1"+type].value <  newData["oi"+type]) {
    //   if (criticalData.current["hightestOI_1"+type].strike !== strike) {
    //     saveCriticalPoints({...criticalData.current, ["hightestOI_1"+type] : {value : newData["oi"+type], strike : strike}});
    //   }
    // }

    // if (criticalData.current["hightestOI_1"+type].value  <= criticalData.current["hightestOI_2"+type].value && criticalData.current["hightestOI_2"+type].value <  newData["oi"+type]) {
    //   if (criticalData.current["hightestOI_2"+type].strike !== strike) {
    //     saveCriticalPoints({...criticalData.current, ["hightestOI_2"+type] : {value : newData["oi"+type], strike : strike}});
    //   }
    // }


    // if (criticalData.current["hightestOIChg"+type].value <  newData["oiChg"+type]) {
    //   if (criticalData.current["hightestOIChg"+type].strike !== strike) {
    //     saveCriticalPoints({...criticalData.current, ["hightestOIChg"+type] : {value : newData["oiChg"+type], strike : strike}});
    //   }

    // }
    // if (criticalData.current["lowestOI"+type].value >  newData["oi"+type]) {
    //   if (criticalData.current["lowestOI"+type].strike !== strike) {
    //     saveCriticalPoints({...criticalData.current, ["lowestOI"+type] : {value : newData["oi"+type], strike : strike}});
    //   }
    // }
    // if (criticalData.current["lowestOIChg"+type].value >  newData["oiChg"+type]) {
    //   if (criticalData.current["lowestOIChg"+type].strike !== strike) {
    //     saveCriticalPoints({...criticalData.current, ["lowestOIChg"+type] : {value : newData["oiChg"+type], strike : strike}});
    //   }
    // }
  }

  const handleResponse = (message, type, strike, token) => {
    if (rowDataRef.current && !isEmptyObject(rowDataRef.current)) {
      const myJSON = JSON.stringify(message);
      const text = safeTagsReplace(myJSON);
      const data = JSON.parse(text)?.data;
 

      if(tickData[token]) {
          tickData[token].lp = data.lp
          dispatch(saveOPtickData(tickData))
      } 
      if(prevData) {
        let newData = {...rowDataRef.current, ...getStock(data, type, prevData)};
        newData['pcrCE'] = newData.oiCE !== 0 ? (newData.oiPE / newData.oiCE) : undefined;
        newData['pcrPE'] = newData.oiCE !== 0 ? (newData.oiPE / newData.oiCE) : undefined;
        rowDataRef.current = newData;
 
        strikeData[strike] = newData;
         //dispatch(saveStrikeData({...strikeData}))
          if(middleStrike === strike) {
             // console.log("newData['lpCE'] + newData['lpPE']", newData['lpCE'], '+', newData['lpPE'] , newData['lpCE'] + newData['lpPE'])
              //dispatch(saveSyntPrice((parseFloat(strike)+parseFloat(newData.lpCE))-parseFloat(newData.lpPE)))
          }
        adjustCriticalPoints(newData, type, ''+strike);
        // setRowData(newData);
        updateValue(newData, type, strike);
        //saveSymbolData(newData, strike)
      }
      //
    }
  };
  // var count = 0;
  function updateValue(newData, type, strike) {
    for(let i = 0; i < columnIds.length; i++) {
      var div = document.getElementById(strike+'-'+columnIds[i]+'-price');
      if(div) {
         
        var val =  getFormattedValue(newData[columnIds[i]], columns[columnIds[i]].lotSizeChg, columns[columnIds[i]].cellType);
        var decimals = columns[columnIds[i]].decimals;
        var isString = columns[columnIds[i]].isString;
        var chkbox = columns[columnIds[i]].key;
        if(!chkbox.includes('chkbox')) {
          var fval = !isNaN(val) ?  fmt(val ? decimals === -1 ? val : val.toFixed(decimals) : val === 0 ? 0 : '-') : isString ? val : '-';
          // var prec = columnIds[i]=="ivChgCE"|| columnIds[i]=="ivChgPE" || columnIds[i]=="pChgCE" || columnIds[i]=="pChgPE" || columnIds[i]=="ltpChgPOpenCE" || columnIds[i]=="ltpChgPOpenPE" || columnIds[i]=="oiPChgCE" || columnIds[i]=="oiPChgPE" ?"%":"";
          if(columnIds[i] == "oiCE" || columnIds[i] == "oiPE" || columnIds[i] == "oiChgCE" || columnIds[i] == "oiChgPE") {
            fval = formatNumberToText(val,'lakh');
          }
          if(columnIds[i] === "synFut") {
            div.innerHTML = "<p>-</p>";
          } else if(columnIds[i] === "straddlePrice") {
            var straddlePrice = newData['lpCE'] + newData['lpPE'];
            div.innerHTML = "<p>"+fmt(straddlePrice.toFixed(2))+"</p>";
          } else {
            div.innerHTML = "<p>"+fval+"</p>";
          }
         
        }

        // var Linewidth = 0;
        // if(oicepeData) {
        //    Linewidth = (chkbox=="oiCE" ? newData[columnIds[i]] / oicepeData.ceoiPer : newData[columnIds[i]] / oicepeData.peoiPer)*2.8; 
        // }

        // if(chkbox == "oiCE") {
        //   div.innerHTML += "<span class='nagtive_chg_v' style='width:"+Linewidth+"%'></span>";
        // }

        // if(chkbox == "oiPE") {
        //   div.innerHTML += "<span class='postive_chg_v' style='width:"+Linewidth+"%'></span>";
        // }

        // if(count == 100 && (columnIds[i] == "oiPChgPE" || columnIds[i] == "oiPChgCE" || columnIds[i] == "oiChgCE" ||  columnIds[i] == "oiChgPE" || columnIds[i] == "oiCE" || columnIds[i] == "oiPE")) {
        //   count = 0;
        //   div.innerHTML = fval+prec;
        // } else if(columnIds[i] != "oiPChgPE" || columnIds[i] != "oiPChgCE" || columnIds[i] != "oiChgCE" ||  columnIds[i] != "oiChgPE" || columnIds[i] != "oiCE" || columnIds[i] != "oiPE") {
        //    div.innerHTML = fval+prec;
        // }
      }
      //count++;
    }
  }

  const tagsToReplace = { "&": "&amp;", "<": "&lt;", ">": "&gt;" };

  function handleSubscribeError(err) {
    console.log("Error subscribing on channel symbol ", tokens, err);
  }

  function replaceTag(tag) {
    return tagsToReplace[tag] || tag;
  }

  function safeTagsReplace(str) {
    return str.replace(/[&<>]/g, replaceTag);
  }

  const getFormattedValue = (value, lotSizeChg, cellType) => {

    if (lotSizeEnabled) {
      let lotSize = cellType === "PE" ? lotSizesByToken[tokens.PE] : lotSizesByToken[tokens.CE]

      if (lotSizeChg === 0) {
        return value;
      } else if (lotSizeChg === 1) {
        return value * lotSize;
      } else if (lotSizeChg === 2) {
        return value / lotSize;
      }
    } else {
      return value;
    }
  }

  return (
    <TableRow
      ref={strike === middleStrike ? ref : null}
      className={rowClasses}>
      {columnIds &&
        rowData &&
        !isEmptyObject(rowData) &&
        columnIds.length > 0 &&
        columnIds.map((column) => (

          <DataTableCell
            rowData={rowData}
            align={isStraddle === "Straddle" ? 'center' : columns[column].align}
            id={columns[column].key}
            key={columns[column].key}
            val={getFormattedValue(rowData[columns[column].key], columns[column].lotSizeChg, columns[column].cellType)}
            withoutLotval={rowData[columns[column].key]}
            decimals={columns[column].decimals}
            isChg={columns[column].isChgItem}
            cls={columns[column].cls}
            cellType={columns[column].cellType}
            rowClasses={rowClasses}
            isString={columns[column].isString}
            minWidth={columns[column].minWidth}
            tokens={tokens}
            showBuySell={showBuySell}
            onChangeToggle={onChangeToggle}
            selectedStrikes={selectedStrikes}
            lotSizeEnabled={lotSizeEnabled}
            strike={strike}
            oicepeData={oicepeData}
            page={page}
            comp={comp}
            middleStrike={middleStrike}
            buySellClick={buySellClick}
            straddlePrice={straddlePrice}
            chartClick={chartClick}
            rowHover={rowHover}
            info={info}
            isPosition={isPosition}
            isFlipped={isFlipped}
          />
        ))}
    </TableRow>
  );
});

export default memo(DataTableRow);
